module.exports = __webpack_public_path__ + "static/media/equifax.e8371c48.jpg";